var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play",on:{"click":_vm.onclick}},[_c('span',{class:{start: !_vm.isPlaying, stop: _vm.isPlaying},attrs:{"id":"start"}}),_c('span',{staticClass:"play-bottom"},[_vm._v("再生/停止")])])
}
var staticRenderFns = []

export { render, staticRenderFns }